import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Audit-index-1992f2b759facf08f-1'),
    routerUrl: '/Audit',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Audit')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Audit-index-1992f2b759facf08f-2'),
        routerUrl: '/AuditForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./AuditForm')),
      },
      //$MORE$
    ],
  },
];
